__turbopack_context__.v({
  "block": "CaseStudySummary-module__Y4xrMW__block",
  "decision": "CaseStudySummary-module__Y4xrMW__decision",
  "decisionTitle": "CaseStudySummary-module__Y4xrMW__decisionTitle",
  "decisions": "CaseStudySummary-module__Y4xrMW__decisions",
  "evidence": "CaseStudySummary-module__Y4xrMW__evidence",
  "eyebrow": "CaseStudySummary-module__Y4xrMW__eyebrow",
  "grid": "CaseStudySummary-module__Y4xrMW__grid",
  "label": "CaseStudySummary-module__Y4xrMW__label",
  "list": "CaseStudySummary-module__Y4xrMW__list",
  "outcome": "CaseStudySummary-module__Y4xrMW__outcome",
  "root": "CaseStudySummary-module__Y4xrMW__root",
  "source": "CaseStudySummary-module__Y4xrMW__source",
});
